import { fromDatetimeLocalValue } from './tournamentDateTime';
import { getDateAsUtc } from './getStringDate';
import { Values } from '../pages/tourDetails/Information/components/InformationTag/InformationTag';

export const infoTagTypeConverter = (infoValues: Values, timeZone?: string) => {
  const customFieldNames = [
    'startDate',
    'endDate',
    'lastCancelationDate',
    'registrationOpen',
    'registrationClose',
  ];

  const toUtc = (value: string) =>
    timeZone ? fromDatetimeLocalValue(value, timeZone) : getDateAsUtc(value);

  const dateValues = Object.entries(infoValues).reduce(
    (acc, [k, v]) =>
      v !== null && customFieldNames.includes(k) ? { ...acc, [k]: toUtc(v) } : acc,
    {}
  );

  const isFeatured = infoValues.isFeatured === true || infoValues.isFeatured === 'true';
  const { isFeatured: _isFeatured, ...scalarValues } = infoValues;

  return {
    ...scalarValues,
    ...dateValues,
    registrationFee:
      infoValues.registrationFee !== null ? Number(infoValues.registrationFee) : null,
    sections: infoValues.sections.map((section) => {
      if (typeof section.id === 'string') {
        return { title: section.title, description: section.description || null };
      } else {
        return section;
      }
    }),
    featureOrder: isFeatured ? Number(infoValues.featureOrder) : null,
  };
};
